var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnegYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000110454085555434523620000014225671256782556811_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 175.4 56",
    style: {
      enableBackground: "new 0 0 175.4 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4C615;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.8,19.4c0-5.5-1.8-10.1-5.5-13.8S116,0,110.1,0s-11,1.8-14.9,5.5c-3.9,3.7-5.8,8.5-5.8,14.5v0.3 c0,6,1.9,10.8,5.8,14.4c3.9,3.6,8.9,5.4,15.2,5.4s11.4-2.1,15.8-6.3c0.4-0.4,0.4-1,0-1.4l-5.2-5c-0.4-0.4-0.9-0.4-1.3,0 c-2.5,2.1-5.4,3.1-8.7,3.1c-6,0-9.9-3-10.2-7.5h0c-0.1-0.8-0.2-1.8-0.2-3c0-1.9,0.1-3.3,0.2-4.4h0c0.3-3.6,4.3-6.4,9.3-6.4 c4.6,0,8.3,2.8,8.3,6.4H106c-0.5,0-0.9,0.4-1,0.9c-0.1,0.9-0.1,2-0.1,3.5c0,0.8,0,1.5,0.1,2.1c0,0.5,0.5,0.9,1,0.9h22.7 c0.5,0,1-0.4,1-0.9C129.7,21.3,129.8,20.4,129.8,19.4L129.8,19.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.7,1v37.3c0,0.5,0.5,1,1,1H57c0.5,0,1-0.5,1-1V1H46.7L46.7,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.2,0.2c-2.2,0-4.3,0.4-6,1.1c-0.4,0.1-0.6,0.5-0.6,0.9v7.2c0,0.6,0.6,1.1,1.2,0.9s1.3-0.2,2-0.2 c3.8,0.1,6.8,3.4,6.8,7.2V37c0,1.8,0.4,2.2,1,2.2h9.3c0.6,0,1-0.5,1-1V16C83.8,6.1,78.5,0.2,69.2,0.2L69.2,0.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.8,1c-0.6,0-1,0.5-1,1v18.1l0,0c0,0,0,0,0,0c0,2.7-1,4.9-3,6.7c-1.9,1.8-4.2,2.7-7.1,2.7s-5-0.9-6.9-2.7 c-1.9-1.8-2.8-4-2.8-6.7s0.9-4.9,2.8-6.8c1.9-1.9,4.2-2.8,6.9-2.8c1.5,0,2.8,0.2,4.1,0.8c0.7,0.3,1.4-0.2,1.4-0.9V2.6 c0-0.4-0.2-0.7-0.6-0.9c-1.9-0.9-4.3-1.4-6.9-1.4c-5.4,0-9.9,1.9-13.6,5.8c-3.6,3.8-5.4,8.5-5.4,14s1.8,10.1,5.4,13.8 c3.6,3.7,8.2,5.5,13.6,5.5s10.1-1.9,11.7-4.6v0.8c0,4-1.1,6.8-3.3,8.4c-1.9,1.3-4.6,2-7.8,2c-3.7,0-7.4-1-11-3.2 c-0.5-0.3-1.1-0.1-1.3,0.3l-4.3,6.6c-0.3,0.5-0.2,1.1,0.3,1.4c4.9,3.2,10.9,4.8,17.9,4.8c5.5,0,10.2-1.4,13.9-4.4 c5.2-4,6.7-9.8,6.7-18.7V2c0-0.5-0.4-1-1-1H165.8L165.8,1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29,1.2L11.3,19.6V1.9c0-0.6-0.4-1-1-1H1c-0.6,0-1,0.4-1,1v36.4c0,0.5,0.4,1,1,1h4.1c0.3,0,0.5-0.1,0.7-0.3 L40.1,2.6c0.6-0.6,0.2-1.7-0.7-1.7h-9.7C29.4,0.9,29.1,1,29,1.2L29,1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.5,23.2l-6.3,6.7L29,39c0.2,0.2,0.5,0.3,0.7,0.3h9.7c0.9,0,1.3-1,0.7-1.7C40.1,37.6,26.6,23.2,26.5,23.2z "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnegYellow);
export default __webpack_public_path__ + "static/media/kneg-yellow.12ca0c35512e237ae8a225acd4b0c686.svg";
export { ForwardRef as ReactComponent };